export default __webpack_public_path__ + "static/media/appc1taxi.b2774fcd.png";